import axios from 'axios'
import qs from 'qs'
import { Toast } from 'vant'

let count = 0
let queue = []

const commonConfig = {
  timeout: 10 * 1000
}

function handleLoading(config, type) {
  if (config.loading === false) {
    return
  }
  if (type === 'add') {
    count++
    if (count > 0) {
      Toast.loading({
        message: 'Loading...',
        duration: 0,
        forbidClick: true
      })
    }
  } else if (type === 'sub') {
    count--
    if (count === 0) {
      Toast.clear()
    }
  }
}

function handleQueue(config, type) {
  const item = config.method + '&' + config.url
  const index = queue.indexOf(item)
  if (type === 'add') {
    if (index === -1) {
      queue.push(item)
      return true
    } else {
      return false
    }
  } else if (type === 'sub') {
    queue.splice(index, 1)
  }
}

const _axios = axios.create(commonConfig)

_axios.interceptors.request.use(
  config => {
    handleLoading(config, 'add')
    return config
  },
  error => {
    handleQueue(error.config, 'sub')
    handleLoading(error.config, 'sub')
    console.log(error)
    return Promise.reject(error)
  }
)

_axios.interceptors.response.use(
  response => {
    handleQueue(response.config, 'sub')
    handleLoading(response.config, 'sub')
    return response.data
  },
  error => {
    handleQueue(error.config, 'sub')
    handleLoading(error.config, 'sub')
    if (error.message.indexOf('timeout') > -1) {
      Toast('请求超时，请重新再试')
    } else {
      Toast(error.message)
    }
    console.log(error)
    return Promise.reject(error)
  }
)

export const Axios = _axios

const axiosPlugin = {
  install(Vue, options) {
    // this.$get
    Vue.prototype.$get = config => {
      const _config = config
      _config.method = 'GET'
      return new Promise((resolve, reject) => {
        if (options && options.ends) {
          Toast('活动已结束')
          return
        }
        if (!handleQueue(_config, 'add')) {
          console.log('重复提交')
          return
        }
        _axios
          .request(_config)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    }
    // this.$post
    Vue.prototype.$post = config => {
      const _config = config
      _config.method = 'POST'
      _config.data = qs.stringify(config.data)
      return new Promise((resolve, reject) => {
        if (options && options.ends) {
          Toast('活动已结束')
          return
        }
        if (!handleQueue(_config, 'add')) {
          console.log('重复提交')
          return
        }
        _axios
          .request(_config)
          .then(res => {
            resolve(res)
          })
          .catch(err => {
            reject(err)
          })
      })
    }
  }
}

export default axiosPlugin
